import { render, staticRenderFns } from "./ModernAntimatterGalaxyRow.vue?vue&type=template&id=e39fcd52&"
import script from "./ModernAntimatterGalaxyRow.vue?vue&type=script&lang=js&"
export * from "./ModernAntimatterGalaxyRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports